import { render, staticRenderFns } from "./regionGroup.vue?vue&type=template&id=1ad1027b&scoped=true"
import script from "./regionGroup.vue?vue&type=script&lang=js"
export * from "./regionGroup.vue?vue&type=script&lang=js"
import style0 from "./regionGroup.vue?vue&type=style&index=0&id=1ad1027b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad1027b",
  null
  
)

export default component.exports